/**
 * ARAYÜZ SÜRÜM ANAHTARI
 *
 * Faz 2 mobil düzeni geri alınabilir bir anahtarın arkasında duruyor.
 * Eski düzen hiç bozulmadan yerinde kalır; ikisini yan yana karşılaştırmak
 * ve sorun çıkarsa anında geri dönmek için.
 *
 *   #v2  -> yeni mobil düzen (tercih hatırlanır)
 *   #v1  -> eski düzene dön
 *
 * Neden hash, neden `?v2` değil: adres çubuğundaki sorgu dizesi paylaşım
 * linkleri için kullanılıyor (`?future/coal/desen` — HawkUtils.parseURLParams).
 * Oraya bir parametre eklemek o biçimi bozardı.
 *
 * KARARI BURASI VERMİYOR. `index.html` içindeki satır içi blok, stil dosyası
 * uygulanmadan önce `.ui-v2` sınıfını ve `window.HAWK_UI_V2` bayrağını
 * kuruyor. Bu modül yalnızca sonucu okur.
 *
 * Sebep: bu modül `defer` edilmiş bir paketin parçası. Karar burada
 * verilseydi sayfa önce v1 stilleriyle boyanır, sonra v2'ye atlardı —
 * açılışta gözle görülür bir "eski tasarım flaşı" oluşuyordu.
 */

export const v2Aktif = document.documentElement.classList.contains('ui-v2');
export const arayuzSurumu: 'v1' | 'v2' = v2Aktif ? 'v2' : 'v1';

/** v2 düzeni yalnızca mobil genişlikte devreye giriyor. */
export const mobilMi = window.matchMedia('(max-width: 767px)').matches;

/**
 * Devralınan `HawkUIController.initMobileUI()` (eski 3 sayfalık mobil
 * sihirbaz) bu bayrakla atlanıyor. Yalnızca mobil + v2 durumunda:
 * masaüstünde eski davranış olduğu gibi sürmeli.
 *
 * Neden burada, index.html'deki satır içi blokta değil: orası
 * `<meta name="viewport">` etiketinden önce çalışıyor ve o ana kadar
 * telefonlarda düzen genişliği ~980px sayıldığı için `matchMedia` yanlış
 * cevap veriyor. Bu modül DOM ayrıştıktan sonra çalışıyor, ölçüm doğru.
 *
 * Sıralama: main.ts bu modülü HawkUIController'dan ÖNCE import ediyor,
 * dolayısıyla bayrak kurucu çalışmadan yerinde oluyor.
 */
if (v2Aktif && mobilMi) {
  window.HAWK_UI_V2 = true;
}

if (v2Aktif) {
  console.log(
    `[Hawk] Yeni düzen anahtarı açık — ${mobilMi ? 'mobil düzen etkin' : 'masaüstünde eski düzen kullanılıyor'} (#v1 ile kapatabilirsiniz)`,
  );
}
